import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import styled from 'styled-components';
import { borderRadius } from '../../node_modules/styled-system/dist/index.esm.js';
import { VStack } from '../layout/Stack.js';
import { variant } from '../../node_modules/@styled-system/variant/dist/index.esm.js';
import { space } from '../../node_modules/@styled-system/space/dist/index.esm.js';
import { shadow } from '../../node_modules/@styled-system/shadow/dist/index.esm.js';
import { layout } from '../../node_modules/@styled-system/layout/dist/index.esm.js';
import { color } from '../../node_modules/@styled-system/color/dist/index.esm.js';
import { flexbox } from '../../node_modules/@styled-system/flexbox/dist/index.esm.js';
var StyledCard = styled.div(variant({
  prop: "elevation",
  variants: {
    0: {
      boxShadow: "none"
    },
    1: {
      boxShadow: "0px 1px 0px rgba(0, 0, 0, 0.05)"
    },
    2: {
      boxShadow: "rgb(0 0 0 / 10%) 0px 9px 33px"
    },
    3: {
      boxShadow: "rgb(0 0 0 / 5%) 0px 13px 39px;"
    }
  }
}), {
  overflowX: "hidden",
  transform: "translateZ(0%)"
}, space, shadow, layout, borderRadius, color, flexbox);
StyledCard.defaultProps = {
  paddingLeft: "10px",
  paddingRight: "10px",
  paddingTop: "10px",
  paddingBottom: "10px"
};
var CardContainer = function CardContainer(_a) {
  var children = _a.children,
    rest = __rest(_a, ["children"]);
  return React__default.createElement(StyledCard, __assign({}, rest), React__default.createElement(VStack, {
    height: "100%"
  }, children));
};
export { CardContainer };